/** @file Doc-only ShownAttachment: a slot's setup placeholder resolved through the default skin. */
import type { Doc } from '@pose2d/format/types';
import type { ShownAttachment } from './meshTarget';

/** What a slot shows at setup with the default skin (the Weights panel's resolver when no mesh tool is active). */
export function setupShownAttachment(doc: Doc): ShownAttachment {
  const entries = doc.skins[doc.defaultSkin]?.entries ?? [];
  return (slot) => {
    const placeholder = doc.slots[slot]?.setup.attachment ?? null;
    if (placeholder === null) return null;
    return entries.find((e) => e.slot === slot && e.placeholder === placeholder)?.attachment ?? null;
  };
}
